import { axios } from '../../clients/axios'

export default {
  namespaced: true,
  state: {
    loggingIn: false,
    loginError: null,
    loginSuccessful: false,
    user: {}
  },
  getters: {
    auth: () => !!localStorage.getItem('token'),
    getUser: (state) => state.user
  },
  mutations: {
    loginStart: (state) => (state.loggingIn = true),
    loginStop: (state, errorMessage) => {
      state.loggingIn = false
      state.loginError = errorMessage
      state.loginSuccessful = !errorMessage
    },
    logout: (state) => {
      state.loggingIn = false
      state.loginSuccessful = false
      state.user = null
    },
    setUser: (state, user) => {
      state.user = user
    },
    setUserTour: (state, tour) => {
      state.user.tour = tour
    }
  },
  actions: {
    doLogin({ commit }, loginData) {
      commit('loginStart')

      axios.defaults.withCredentials = true
      return axios
        .post(`${process.env.VUE_APP_API_URL}/login`, {
          ...loginData
        })
        .then((data) => {
          if (data && data.data && data.data.success) {
            commit('loginStop', null)
            commit('setUser', data.data.user)
            localStorage.setItem('token', data.data.token)
            // session storage can be tab specific
            sessionStorage.setItem('propertyId', data.data.property.propertyId)
            localStorage.setItem('propertyId', data.data.property.propertyId)
            return { success: true }
          } else {
            commit('loginStop', 'Invalid Credentials')
            return {
              success: false,
              message: 'Username or Password is incorrect'
            }
          }
        })
        .catch((error) => {
          //eslint-disable-next-line
          console.log(error)
          commit('loginStop', error.response.data.error)
          return {
            success: false,
            message:
              'There was a problem with the request. Please try again later'
          }
        })
    },
    async doLogout({ commit }) {
      localStorage.removeItem('token')
      localStorage.removeItem('property')
      localStorage.removeItem('subscriptionStart')
      localStorage.removeItem('subscriptionEnd')
      localStorage.removeItem('propertyId')
      sessionStorage.removeItem('propertyId')
      commit('logout')

      return await axios.get(`${process.env.VUE_APP_API_URL}/logout`, {
        withCredentials: true
      })
    },
    async fetchCurrentUserAction({ commit }) {
      const user = await axios.get(
        `${process.env.VUE_APP_API_URL}/users/current`,
        { withCredentials: true }
      )
      let currentUser = user.data

      if (
        !currentUser.selectedProperty ||
        currentUser.selectedProperty.propertyId == null
      ) {
        currentUser.selectedProperty = currentUser.properties[0]
      }
      commit('setUser', currentUser)
    },
    doSignup(context, signupData) {
      axios.defaults.withCredentials = true

      return axios
        .post(`${process.env.VUE_APP_API_URL}/signup`, {
          ...signupData
        })
        .then((data) => {
          if (data && data.data && data.data.success) {
            return { success: true }
          } else {
            return { success: false }
          }
        })
        .catch((err) => {
          let response = 'There was an error processing your request.'
          if (err.response.data == 'DUPLICATE_EMAIL_USERNAME_ERROR') {
            response = 'A user with that email or username already exists'
          } else if (err.response.data == 'DUPLICATE_CONTACT_NUMBER_ERROR') {
            response = 'A user is already associated with the contact number'
          }
          return { success: false, message: response }
        })
    },
    async stopTour(context, params) {
      const { section } = params

      const tour = await axios.put(
        `${process.env.VUE_APP_API_URL}/users/tour/${section}`,
        {},
        { withCredentials: true }
      )

      context.commit('setUserTour', tour.data)

      return tour.data
    },
    async updateAccountAction(context, params) {
      try {
        const {
          username,
          firstName,
          lastName,
          birthday,
          contactNumber1,
          contactNumber2
        } = params

        const user = await axios.put(
          `${process.env.VUE_APP_API_URL}/users/user`,
          {
            username,
            firstName,
            lastName,
            birthday,
            contactNumber1,
            contactNumber2
          },
          { withCredentials: true }
        )

        return Promise.resolve(user)
      } catch (err) {
        let response = ''
        if (err.response.data === 'UPDATE_USER_ERROR') {
          response = 'There was an error processing your request.'
        }
        return Promise.reject(response)
      }
    },
    async forgotPasswordAction(context, params) {
      try {
        const { email } = params

        const success = await axios.post(
          `${process.env.VUE_APP_API_URL}/public/forgotpassword`,
          { email }
        )

        return Promise.resolve(success)
      } catch (err) {
        let response = ''
        if (err.response.data === 'UPDATE_USER_ERROR') {
          response = 'There was an error processing your request.'
        }
        return Promise.reject(response)
      }
    },
    async updateEmailRequestAction(context, params) {
      try {
        const { email } = params

        const success = await axios.post(
          `${process.env.VUE_APP_API_URL}/users/updateEmailRequest`,
          { email },
          { withCredentials: true }
        )

        return Promise.resolve(success)
      } catch (err) {
        let response = 'There was an error processing your request.'
        if (err.response.data === 'UPDATE_EMAIL_REQUEST_ERROR') {
          response = 'There was an error processing your request.'
        } else if (
          err.response.data === 'UPDATE_EMAIL_REQUEST_USER_EXISTS_ERROR'
        ) {
          response =
            'A user is already with that email. Please choose a different email address.'
        }
        return Promise.reject(response)
      }
    },
    async updateEmailAction(context, params) {
      try {
        const { username, password } = params
        const success = await axios.post(
          `${process.env.VUE_APP_API_URL}/public/users/updateEmail`,
          { username, password }
        )

        return Promise.resolve(success)
      } catch (err) {
        let response = 'There was an error processing your request.'
        if (err.response.data === 'UPDATE_EMAIL_ERROR') {
          response = 'There was an error processing your request.'
        } else if (err.response.data === 'UPDATE_EMAIL_INVALID_CREDENTIALS') {
          response = 'The password you entered is invalid'
        }
        return Promise.reject(response)
      }
    },
    async changeCurrentPropertyAction(context, params) {
      try {
        const { propertyId } = params
        const data = await axios.post(
          `${process.env.VUE_APP_API_URL}/users/changeSelectedProperty`,
          { propertyId },
          { withCredentials: true }
        )
        localStorage.setItem('propertyId', data.data.property.propertyId)
        sessionStorage.setItem('propertyId', data.data.property.propertyId)

        await context.dispatch('fetchCurrentUserAction')
        // add this to fetch the updated property right away
        const property = await context.dispatch(
          'properties/fetchPropertyAction',
          null,
          { root: true }
        )

        if (
          property.status == 'rejected' ||
          new Date(property.subscriptionStart) > new Date() ||
          new Date(property.subscriptionEnd) < new Date()
        ) {
          return Promise.reject('EXPIRED_PROPERTY')
        }

        return Promise.resolve(data)
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async agreePrivacyTC() {
      try {
        const agree = await axios.post(
          `${process.env.VUE_APP_API_URL}/users/agreePrivacyTC`,
          {},
          { withCredentials: true }
        )

        return Promise.resolve(agree)
      } catch (err) {
        return Promise.reject(err)
      }
    }
  }
}
